export default __webpack_public_path__ + "static/media/formGoFill.d574d7bd.svg";